(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[196],{

/***/ 8731:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[language]/contact",
      function () {
        return __webpack_require__(549);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useSetGlobalAppLanguage; },
/* harmony export */   "j": function() { return /* binding */ useBuildMetaTitle; }
/* harmony export */ });
/* harmony import */ var _redux_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6410);
/* harmony import */ var _redux_layoutSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7794);
/* harmony import */ var _xFrame4_components_Hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8611);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function useBuildMetaTitle(pageTitle) {
    var t = (0,_xFrame4_components_Hooks__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    return t("APP_TITLE") + " | " + t(pageTitle !== null && pageTitle !== void 0 ? pageTitle : "");
}
/** 
 * Hook: set the global app language with Redux.
 */ function useSetGlobalAppLanguage(language) {
    var dispatch = (0,_redux_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useAppActionDispatch */ .a)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        dispatch((0,_redux_layoutSlice__WEBPACK_IMPORTED_MODULE_1__/* .setAppLanguage */ .$M)(language));
    }, [
        language
    ]);
}


/***/ }),

/***/ 299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var PageTitle = function(props) {
    /** Render */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "page-title",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "font-size-3 mb-3 fw-bold",
            children: props.title
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/common/PageTitle.tsx
var PageTitle = __webpack_require__(299);
// EXTERNAL MODULE: ./config.ts
var config = __webpack_require__(8288);
// EXTERNAL MODULE: ./redux/hooks.ts
var hooks = __webpack_require__(6410);
// EXTERNAL MODULE: ./xFrame4/business/AppSetting.ts
var AppSetting = __webpack_require__(4851);
// EXTERNAL MODULE: ./xFrame4/components/Hooks.ts + 3 modules
var Hooks = __webpack_require__(8611);
// EXTERNAL MODULE: ./xFrame4/components/next/ALink.tsx
var ALink = __webpack_require__(2768);
// EXTERNAL MODULE: ./xFrame4/components/SmoothImage.tsx
var SmoothImage = __webpack_require__(5423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(6626);
// EXTERNAL MODULE: ./xFrame4/business/BusinessEntity.ts
var BusinessEntity = __webpack_require__(628);
// EXTERNAL MODULE: ./xFrame4/business/User.ts
var User = __webpack_require__(6939);
;// CONCATENATED MODULE: ./business/messaging/ContactMessage.ts





/**
 * A contact message sent either by an user or a anonymous user.
 */ var ContactMessage = /*#__PURE__*/ function(BusinessEntity) {
    "use strict";
    (0,_inherits/* default */.Z)(ContactMessage, BusinessEntity);
    var _super = (0,_create_super/* default */.Z)(ContactMessage);
    function ContactMessage() {
        (0,_class_call_check/* default */.Z)(this, ContactMessage);
        var _this;
        _this = _super.apply(this, arguments);
        _this.user = null;
        _this.name = "";
        _this.email = "";
        _this.phone = "";
        _this.message = "";
        _this.source = "";
        return _this;
    }
    return ContactMessage;
}(BusinessEntity/* default */.ZP);
ContactMessage.manager = new BusinessEntity/* EntityManager */.v2({
    name: "ContactMessage",
    createEntity: function() {
        return new ContactMessage();
    },
    fields: [
        {
            name: "dateAdded",
            isInput: false
        },
        {
            name: "user",
            inputName: "userId",
            inputProperty: "user.id",
            relatedManager: User/* default.manager */.Z.manager
        },
        {
            name: "name"
        },
        {
            name: "email"
        },
        {
            name: "phone"
        },
        {
            name: "message",
            isRequiredInput: true
        },
        {
            name: "source"
        }, 
    ],
    graphQlQueryAlias: "contactMessages"
});
/* harmony default export */ var messaging_ContactMessage = (ContactMessage);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/FloatingLabel.js
var FloatingLabel = __webpack_require__(2230);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 12 modules
var Form = __webpack_require__(1358);
// EXTERNAL MODULE: ./node_modules/@tinymce/tinymce-react/lib/es2015/main/ts/index.js + 5 modules
var ts = __webpack_require__(6235);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./xFrame4/common/Utils.ts + 1 modules
var Utils = __webpack_require__(7092);
;// CONCATENATED MODULE: ./xFrame4/components/CheckboxList.tsx






var CheckboxListLayout;
(function(CheckboxListLayout) {
    CheckboxListLayout[CheckboxListLayout["Vertical"] = 0] = "Vertical";
    CheckboxListLayout[CheckboxListLayout["Horizontal"] = 1] = "Horizontal";
})(CheckboxListLayout || (CheckboxListLayout = {}));
var CheckboxList = function(props) {
    var ref = (0,react.useState)(props.value), checkedItems = ref[0], setCheckedItems = ref[1];
    if (props.value !== undefined && props.value != checkedItems) setCheckedItems(props.value); // hack: forcing 'checked' to be the value
    /** Handle the checkbox toggle for an item. */ var handleToggle = function(item) {
        if (props.disabled) return;
        // Update checked items
        var currentIndex = indexOfItemInList(checkedItems, item);
        var newCheckedItems = (0,_to_consumable_array/* default */.Z)(checkedItems);
        if (currentIndex === -1) {
            newCheckedItems.push(item);
        } else {
            newCheckedItems.splice(currentIndex, 1);
        }
        setCheckedItems(newCheckedItems);
        // Fire the change event
        if (props.onChange) props.onChange(newCheckedItems);
    };
    /** Find the index of an item in the list. */ var indexOfItemInList = function(list, item) {
        return list.findIndex(function(i) {
            return i[props.dataSourceValueMember] == item[props.dataSourceValueMember];
        });
    };
    /** Checkboxes */ var cmpCheckboxes = props.dataSource.map(function(item, i) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
            type: "checkbox",
            label: (0,Utils/* getDataSourceDisplayMemberValue */.g)(item, props.dataSourceDisplayMember),
            checked: checkedItems.some(function(ci) {
                return ci[props.dataSourceValueMember] == item[props.dataSourceValueMember];
            }),
            onChange: function() {
                return handleToggle(item);
            }
        }, i);
    });
    /** Layout */ var classes = "";
    if (props.layout == CheckboxListLayout.Vertical) {
        classes = "";
    } else {
        classes = "d-flex";
    }
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "checkbox-list border p-1 " + classes,
        style: {
            maxHeight: "10rem",
            overflow: "auto"
        },
        children: cmpCheckboxes
    });
};
CheckboxList.defaultProps = {
    dataSourceValueMember: "value",
    dataSourceDisplayMember: "display",
    layout: CheckboxListLayout.Vertical,
    value: []
};
/* harmony default export */ var components_CheckboxList = (CheckboxList);

;// CONCATENATED MODULE: ./xFrame4/components/FieldEditor.tsx








var FieldEditor = function(props) {
    /** Parse the input value in correct format. */ var parseInput = function(value) {
        if (props.type == FieldEditorType.Number && value != null && value != "" && !isNaN(value)) {
            return parseFloat(value);
        } else {
            return value;
        }
    };
    /** Create the input control */ var input = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if ([
        FieldEditorType.Text,
        FieldEditorType.Email,
        FieldEditorType.Password,
        FieldEditorType.Number,
        FieldEditorType.Date, 
    ].includes(props.type)) {
        var _value;
        input = /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
            type: props.type,
            value: (_value = props.value) !== null && _value !== void 0 ? _value : "",
            required: props.isRequired,
            disabled: !props.isEnabled,
            placeholder: props.placeholder,
            maxLength: props.maxLength,
            min: props.min,
            max: props.max,
            onChange: function(event) {
                if (props.onValueChanged) props.onValueChanged(props.field, parseInput(event.target.value));
            },
            onKeyDown: function(event) {
                if (props.onKeyDown) props.onKeyDown(event.key);
            },
            onWheel: function(event) {
                return event.target.blur();
            }
        });
    } else if (props.type == FieldEditorType.Select) {
        var ref;
        var options = (ref = props.dataSource) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            var value = item[props.dataSourceValueMember];
            var display = (0,Utils/* getDataSourceDisplayMemberValue */.g)(item, props.dataSourceDisplayMember);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: value,
                children: display
            }, value);
        });
        var value;
        if (props.value !== null && props.value !== undefined) {
            // Accepts an object or a scalar
            value = typeof props.value == "object" ? props.value[props.dataSourceValueMember] : props.value;
        }
        input = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
            "aria-label": props.label,
            value: value,
            required: props.isRequired,
            disabled: !props.isEnabled,
            placeholder: props.placeholder,
            onChange: function(event) {
                if (props.onValueChanged) {
                    var ref;
                    return props.onValueChanged(props.field, (ref = props.dataSource) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return item[props.dataSourceValueMember] == event.target.value // Find the selected item based on the selected value
                        ;
                    }));
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: ""
                }),
                options
            ]
        });
    } else if (props.type == FieldEditorType.List) {
        input = /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CheckboxList, {
            dataSource: props.dataSource,
            dataSourceDisplayMember: props.dataSourceDisplayMember,
            dataSourceValueMember: props.dataSourceValueMember,
            disabled: !props.isEnabled,
            layout: props.labelPosition == FieldEditorLabelPosition.Floating ? CheckboxListLayout.Horizontal : CheckboxListLayout.Vertical,
            value: props.value,
            onChange: function(selectedItems) {
                if (props.onValueChanged) props.onValueChanged(props.field, selectedItems);
            }
        });
    } else if (props.type == FieldEditorType.Textarea) {
        var _value1;
        input = /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
            className: "form-control",
            rows: 6,
            value: (_value1 = props.value) !== null && _value1 !== void 0 ? _value1 : "",
            required: props.isRequired,
            disabled: !props.isEnabled,
            placeholder: props.placeholder,
            onChange: function(event) {
                if (props.onValueChanged) props.onValueChanged(props.field, event.target.value);
            }
        });
    } else if (props.type == FieldEditorType.RichTextEditor) {
        var _value2;
        input = /*#__PURE__*/ (0,jsx_runtime.jsx)(ts/* Editor */.M, {
            apiKey: "imhy59jyow8r2w71xomakon8g5otmm1x8qexd2u13ejqoxdm",
            value: (_value2 = props.value) !== null && _value2 !== void 0 ? _value2 : "",
            init: {
                height: 500,
                placeholder: props.placeholder,
                menubar: true,
                plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "link",
                    "image",
                    "charmap",
                    "preview",
                    "anchor",
                    "searchreplace",
                    "visualblocks",
                    "code",
                    "fullscreen",
                    "insertdatetime",
                    "media",
                    "table",
                    "code",
                    "help",
                    "wordcount"
                ],
                toolbar: "undo redo | blocks | " + "bold italic forecolor | alignleft aligncenter " + "alignright alignjustify | bullist numlist outdent indent | " + "removeformat | help",
                content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }"
            },
            onEditorChange: function(content, editor) {
                if (props.onValueChanged) props.onValueChanged(props.field, content);
            }
        });
    } else if (props.type == FieldEditorType.Checkbox) {
        var _value3;
        input = /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
            type: "checkbox",
            label: props.label,
            checked: (_value3 = props.value) !== null && _value3 !== void 0 ? _value3 : false,
            className: "d-flex align-items-center",
            onChange: function(event) {
                if (props.onValueChanged) props.onValueChanged(props.field, event.target.checked);
            }
        });
    } else if (props.type == FieldEditorType.File) {
        input = /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
            type: "file",
            required: props.isRequired,
            disabled: !props.isEnabled,
            placeholder: props.placeholder,
            multiple: props.allowMultipleFileUpload,
            onChange: function(event) {
                return fileChangeHandler(event);
            }
        });
    }
    /** Selected file changed. */ var fileChangeHandler = function(event) {
        if (event.target.files != null && event.target.files.length > 0) {
            if (props.onValueChanged !== undefined) {
                props.onValueChanged(props.field, !props.allowMultipleFileUpload ? event.target.files[0] : event.target.files);
            }
        }
    };
    /** Add label */ var cmpInputWithLabel = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    switch(props.labelPosition){
        case FieldEditorLabelPosition.Horizontal:
            {
                cmpInputWithLabel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                    controlId: "field-editor-" + props.field,
                    children: [
                        props.type != FieldEditorType.Checkbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                            children: props.label
                        }),
                        props.beforeInput,
                        input,
                        props.afterInput
                    ]
                });
            }
            break;
        case FieldEditorLabelPosition.Floating:
            {
                cmpInputWithLabel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingLabel/* default */.Z, {
                    controlId: "field-editor-" + props.field,
                    label: props.type != FieldEditorType.Checkbox && props.label,
                    children: [
                        props.beforeInput,
                        input,
                        props.afterInput
                    ]
                });
            }
            break;
        case FieldEditorLabelPosition.Hidden:
            {
                cmpInputWithLabel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                    controlId: "field-editor-" + props.field,
                    children: [
                        props.beforeInput,
                        input,
                        props.afterInput
                    ]
                });
            }
            break;
    }
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "field-editor field-editor-".concat(props.type, " ").concat(props.className),
        style: {
            display: props.isVisible ? "block" : "none"
        },
        children: cmpInputWithLabel
    });
};
var FieldEditorType;
(function(FieldEditorType) {
    FieldEditorType["Text"] = "text";
    FieldEditorType["Email"] = "email";
    FieldEditorType["Password"] = "password";
    FieldEditorType["Number"] = "number";
    FieldEditorType[/** Accepts a list of objects. Single selection. */ "Select"] = "select";
    FieldEditorType[/** Accepts a list of objects. Multiple selection. */ "List"] = "list";
    FieldEditorType["Date"] = "date";
    FieldEditorType["Textarea"] = "textarea";
    FieldEditorType["RichTextEditor"] = "rich-text-editor";
    FieldEditorType["Checkbox"] = "checkbox";
    FieldEditorType["File"] = "file";
})(FieldEditorType || (FieldEditorType = {}));
var FieldEditorLabelPosition;
(function(FieldEditorLabelPosition) {
    FieldEditorLabelPosition[FieldEditorLabelPosition["Vertical"] = 0] = "Vertical";
    FieldEditorLabelPosition[FieldEditorLabelPosition["Horizontal"] = 1] = "Horizontal";
    FieldEditorLabelPosition[FieldEditorLabelPosition["Floating"] = 2] = "Floating";
    FieldEditorLabelPosition[FieldEditorLabelPosition["Hidden"] = 3] = "Hidden";
})(FieldEditorLabelPosition || (FieldEditorLabelPosition = {}));
FieldEditor.defaultProps = {
    labelPosition: FieldEditorLabelPosition.Horizontal,
    dataSourceValueMember: "value",
    dataSourceDisplayMember: "display",
    isRequired: false,
    isVisible: true,
    isEnabled: true,
    allowMultipleFileUpload: false,
    className: ""
};
/**
 * Converts an array of strings to a datasource array.
 * 
 * @param stringArray 
 */ function arrayToDataSource(stringArray) {
    var dataSource = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stringArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var str = _step.value;
            var dataSourceRow = {
                value: str,
                display: str
            };
            dataSource.push(dataSourceRow);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return dataSource;
}
/**
 * Converts an enum to a datasource array.
 * 
 * @param enumObject The object that needs to be converted.
 * @param t A function to translate the key for display.
 */ function enumToDataSource(enumObject, t) {
    var dataSource = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(enumObject)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _sliced_to_array(_step.value, 2), key = _value[0], value = _value[1];
            var dataSourceRow = {
                value: value,
                display: t ? t(key) : key
            };
            dataSource.push(dataSourceRow);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return dataSource;
}
/* harmony default export */ var components_FieldEditor = (FieldEditor);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js + 1 modules
var Button = __webpack_require__(3680);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
;// CONCATENATED MODULE: ./components/contact/ContactForm.tsx












var ContactForm = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var ref = (0,react.useState)(false), validated = ref[0], setValidated = ref[1];
    var ref1 = (0,react.useState)(false), isSaving = ref1[0], setIsSaving = ref1[1];
    var ref2 = (0,react.useState)(false), messageSent = ref2[0], setMessageSent = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)((0,Hooks/* useUpdateEntityFields */.qo)(), 3), contactMessage = ref3[0], setContactMessage = ref3[1], updateEntityField = ref3[2];
    var ref4 = (0,react.useState)(false), captchaWasSuccesful = ref4[0], setCaptchaWasSuccesful = ref4[1];
    /** Create new entity */ (0,react.useEffect)(function() {
        setContactMessage(new messaging_ContactMessage());
    }, []);
    /** Form validate */ var onValidate = function() {
        return captchaWasSuccesful;
    };
    /** Form submit */ var onSubmit = function(event) {
        event.preventDefault();
        event.stopPropagation();
        // Validate
        var form = event.currentTarget;
        if (form.checkValidity() === true) {
            var isValid = true;
            isValid = onValidate(); // Additional custom validation
            // Form is valid: save
            if (isValid) save();
        }
        setValidated(true);
    };
    /** 
     * Captcha change: means that the user succesfully completed the challenge
     * https://www.npmjs.com/package/react-google-recaptcha
     */ var onCaptchaChange = function(value) {
        setCaptchaWasSuccesful(true);
    };
    /** Save the form data. */ var save = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsSaving(true);
                        _ctx.prev = 1;
                        if (!contactMessage) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.t0 = setMessageSent;
                        _ctx.next = 6;
                        return contactMessage.save();
                    case 6:
                        _ctx.t1 = _ctx.sent;
                        (0, _ctx.t0)(_ctx.t1);
                    case 8:
                        setIsSaving(false);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t2 = _ctx["catch"](1);
                        setIsSaving(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function save() {
            return _ref.apply(this, arguments);
        };
    }();
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "contact-form",
        children: [
            messageSent == false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                noValidate: true,
                validated: validated,
                onSubmit: function(event) {
                    return onSubmit(event);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FieldEditor, {
                        type: FieldEditorType.Text,
                        field: "name",
                        label: t("CONTACT_NAME") + " *",
                        placeholder: t("PLACEHOLDER_CONTACT_NAME"),
                        isRequired: true,
                        className: "contact-form-field mb-4",
                        value: contactMessage === null || contactMessage === void 0 ? void 0 : contactMessage.name,
                        onValueChanged: function(field, value) {
                            return updateEntityField(field, value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FieldEditor, {
                        type: FieldEditorType.Text,
                        field: "email",
                        label: t("CONTACT_EMAIL") + " *",
                        placeholder: t("PLACEHOLDER_CONTACT_EMAIL"),
                        isRequired: true,
                        className: "contact-form-field mb-4",
                        value: contactMessage === null || contactMessage === void 0 ? void 0 : contactMessage.email,
                        onValueChanged: function(field, value) {
                            return updateEntityField(field, value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FieldEditor, {
                        type: FieldEditorType.Textarea,
                        field: "message",
                        label: t("CONTACT_MESSAGE") + " *",
                        placeholder: t("PLACEHOLDER_CONTACT_MESSAGE"),
                        isRequired: true,
                        className: "contact-form-field mb-4",
                        value: contactMessage === null || contactMessage === void 0 ? void 0 : contactMessage.message,
                        onValueChanged: function(field, value) {
                            return updateEntityField(field, value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                        sitekey: config/* default.googleCaptchaKey */.Z.googleCaptchaKey,
                        onChange: onCaptchaChange,
                        className: "my-3"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "dark",
                        type: "submit",
                        disabled: isSaving,
                        className: "rounded px-4 py-2",
                        children: t("CONTACT_SUBMIT")
                    })
                ]
            }),
            messageSent && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "contact-form-thank-you ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "alert alert-primary",
                    role: "alert",
                    children: t("CONTACT_FORM_THANK_YOU")
                })
            })
        ]
    });
};
/* harmony default export */ var contact_ContactForm = (ContactForm);

;// CONCATENATED MODULE: ./components/contact/Contact.tsx









var Contact = function(props) {
    var t = (0,Hooks/* useTranslate */.qM)();
    var language = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.language;
    });
    var facebookPage = AppSetting/* default.getValueFromArray */.Z.getValueFromArray(props.appSettings, "facebook_page");
    var instagramPage = AppSetting/* default.getValueFromArray */.Z.getValueFromArray(props.appSettings, "instagram_page");
    var saatchiartUrl = AppSetting/* default.getValueFromArray */.Z.getValueFromArray(props.appSettings, "saatchiart_url");
    /** Social media links */ var socialLinks = [
        /*
        {
            name: 'Facebook',
            link: facebookPage.url
        },
        */ {
            name: "Instagram",
            link: instagramPage.url
        },
        {
            name: "saatchiart",
            link: saatchiartUrl.value
        }
    ];
    var cmpSociaLinks = socialLinks.map(function(socialLink, i) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "contact-social-link me-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                    href: socialLink.link,
                    target: "_blank",
                    className: "content-link",
                    children: socialLink.name
                }),
                i != socialLinks.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ms-2",
                    children: "//"
                })
            ]
        }, i);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "contact",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("CONTACT")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-lg-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-gray-700 mb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("CONTACT_SECTION_2_TITLE")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-social-links d-flex mb-3",
                                    children: cmpSociaLinks
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-desc mb-3",
                                    dangerouslySetInnerHTML: {
                                        __html: t("CONTACT_SECTION_2_DESC")
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "privacy-policy-cta",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ALink/* default */.Z, {
                                        className: "content-link",
                                        href: config/* default.appUrl */.Z.appUrl + language.code + "/privacy",
                                        children: t("CONTACT_SECTION_2_PRIVACY_POLICY_CTA")
                                    })
                                })
                            ]
                        }),
                         false && /*#__PURE__*/ 0,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_ContactForm, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var contact_Contact = (Contact);

// EXTERNAL MODULE: ./components/Hooks.ts
var components_Hooks = __webpack_require__(8133);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 9 modules
var Layout = __webpack_require__(1000);
// EXTERNAL MODULE: ./xFrame4/components/next/CustomHead.tsx
var CustomHead = __webpack_require__(4685);
;// CONCATENATED MODULE: ./pages/[language]/contact.tsx






var ContactPage = function(props) {
    (0,components_Hooks/* useSetGlobalAppLanguage */.e)(props.language);
    /** Meta */ var metaTitle = (0,components_Hooks/* useBuildMetaTitle */.j)("CONTACT");
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHead/* default */.Z, {
                metaData: {
                    title: metaTitle
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                menuItems: props.menuItems,
                appSettings: AppSetting/* default.createArrayFromJson */.Z.createArrayFromJson(props.appSettings),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_Contact, {
                    appSettings: AppSetting/* default.createArrayFromJson */.Z.createArrayFromJson(props.appSettings)
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var contact = (ContactPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [899,82,611,935,774,888,179], function() { return __webpack_exec__(8731); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);